/** Global Imports */
import React from 'react';

/** Component Imports */

/** Common */
import UnauthorizedView from 'components/common/unauthorized';

/** Collaboration */
import Programs from 'components/workflows/ProgramDashboard/programs';
import ProgramHome from 'components/workflows/ProgramDashboard/program-home';

export const collaborationRoutes = {
  programs: {
    key: 'programs',
    path: '/programs',
    component: <Programs />,
    redirects: ['/', '/collaboration'],
    getName: () => 'Dahsboard',
  },
  program: {
    key: 'program',
    path: '/program/:programId',
    component: <ProgramHome />,
    getPath: (programId) => `/program/${programId}`,
    getName: (programName) => programName,
  },
  unauthorized: {
    key: 'unauthorized',
    path: '/unauthorized',
    component: <UnauthorizedView />,
    getName: null,
  },
};

export const applicationEntryRoute = collaborationRoutes.programs;
